import { SuiteManifest } from '../manifest';
import { crmRoutes } from './routes';

export const crmManifest: SuiteManifest = {
  id: 'crm',
  name: 'CRM & Sales',
  basePath: '/crm',
  icon: 'briefcase',
  description: 'Leads, deals, pipelines, and contact relationship management.',
  requiredPermission: 'crm.deal.read',
  nav: [
    { label: 'Pipeline & Deals', path: '/crm/deals', icon: 'trending-up', permission: 'crm.deal.read', group: 'Sales', status: 'live' },
    { label: 'Contacts (Smart CRM)', path: '/crm/contacts', icon: 'users', permission: 'directory.contact.read', group: 'Directory', status: 'live' },
    { label: 'Companies', path: '/crm/companies', icon: 'building', permission: 'directory.company.read', group: 'Directory', status: 'planned' },
  ],
  routes: crmRoutes,
};

export default crmManifest;
